const getters = {
  gSnackbar: state => state.common.gSnackbar,
  gLoading: state => state.common.gLoading
};

export default getters;
